import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { queryKeys } from "../api/queryKeys";

interface Industry {
  cd_fornecedor: number;
  ds_fornecedor: string;
}

export const useIndustries = () => {
  return useQuery<Industry[]>({
    queryKey: queryKeys.industries,
    queryFn: async () => {
      const response = await api.get("industries");
      return response.data;
    },
    staleTime: 15 * 60 * 1000, // 15 minutos
  });
};
